import React from "react";

import facebook from "images/social/facebook.svg";

import { Trans } from "app/utils";

const FacebookBadge = ({ justIcon, useImageIcon }) => {
  if (justIcon) {
    return (
      <p className="SocialBadge facebook">
        <img height="20px" width="20px" className="social-icon" src={facebook} alt="Facebook icon" />
      </p>
    );
  }

  if (useImageIcon) {
    return (
      <p className="SocialBadge facebook">
        <img margin-top="-1px" vertical-align="middle" height="20px" width="20px" className="social-icon" src={facebook} alt="Facebook icon" />
        <Trans> Facebook</Trans>
      </p>
    );
  }

  return (
    <p className="SocialBadge facebook">
      <svg height="15px" viewBox="0 0 224 432" width="22px" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill="#FFFFFF" fillRule="nonzero">
            <path d="M224,64 C224,72.836556 216.836556,80 208,80 L160,80 C151.163444,80 144,87.163444 144,96 L144,160 L204.48,160 C209.273148,160.000019 213.813816,162.1489 216.852831,165.855469 C219.891846,169.562038 221.109057,174.435821 220.1696,179.136 C217.1992,193.992 213.164,214.168 210.5696,227.136 C209.074593,234.61564 202.507585,239.99997 194.88,240 L144,240 L144,432 L64,432 L64,240 L16,240 C7.163444,240 0,232.836556 0,224 L0,176 C0,167.163444 7.163444,160 16,160 L64,160 L64,96 C64,42.980664 106.980664,0 160,0 L208,0 C216.836556,0 224,7.163444 224,16 L224,64 Z" />
          </g>
        </g>
      </svg>
      <Trans>Facebook</Trans>
    </p>
  );
};

export default FacebookBadge;
